import {Component} from '@angular/core';
import {CoreSidebarService} from '@core/components/core-sidebar/core-sidebar.service';
import {DashboardService} from '../dashboard.service';
import {DashboardFacade} from '../store/dashboard.facade';
import { PermissionsService } from 'app/global/permissions/permissions.service';
import { PermissionsEnum } from 'app/global/permissions/permissions.enum';

@Component({
  selector: 'app-dashboard-customizer-sidebar',
  templateUrl: './dashboard-customizer-sidebar.component.html',
  styleUrl: './dashboard-customizer-sidebar.component.scss'
})
export class DashboardCustomizerSidebarComponent {

  public dashboardSettings = this.dashboardFacade.dashboardSettings$;
  public canUploadDocument$ = this._permissionService.isNotRestricted(PermissionsEnum.restrict_access_send_documents_not_templates);

  constructor(
    private _coreSidebarService: CoreSidebarService,
    private dashboardService: DashboardService,
    private dashboardFacade: DashboardFacade,
    private _permissionService: PermissionsService
  ) {  }
  
  dashboardSidebar(name): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  updateSetting(event: Event, key: string)
  {
      const value = (<HTMLInputElement>event.target).checked ? 'active' : 'inactive';
      this.dashboardFacade.updateDashboardSetting(key, value);
  }       
}
